import {
  AvailableComplianceNotifications,
  AvailableTrainingNotifications,
  ComplianceNotificationTypes,
  TrainingNotificationTypes,
} from './notification.models';

export function changeComplianceNotificationStateBasedOnType(
  state: ComplianceNotificationTypes,
  notificationType: AvailableComplianceNotifications,
  activate: boolean,
): ComplianceNotificationTypes {
  switch (notificationType) {
    case AvailableComplianceNotifications.dueToExpire:
      return {
        ...state,
        dueToExpire: { ...state.dueToExpire, active: activate },
      };
    case AvailableComplianceNotifications.expired:
      return { ...state, expired: { ...state.expired, active: activate } };
    case AvailableComplianceNotifications.lapsed:
      return { ...state, lapsed: { ...state.lapsed, active: activate } };
    default:
      return { ...state };
  }
}

export function changeTrainingNotificationStateBasedOnType(
  state: TrainingNotificationTypes,
  notificationType: AvailableTrainingNotifications,
  activate: boolean,
): TrainingNotificationTypes {
  switch (notificationType) {
    case AvailableTrainingNotifications.trainingCancelled:
      return {
        ...state,
        trainingCancelled: { ...state.trainingCancelled, active: activate },
      };
    default:
      return { ...state };
  }
}

export function getTopCompliancePriority(
  notificationStatus: ComplianceNotificationTypes | null,
): AvailableComplianceNotifications | null {
  if (notificationStatus === null) {
    return null;
  }
  let notificationName = null;
  let topPriority = Number.MAX_SAFE_INTEGER;
  let k: keyof ComplianceNotificationTypes;
  for (k in notificationStatus) {
    if (
      notificationStatus[k].active &&
      notificationStatus[k].priority < topPriority
    ) {
      notificationName = notificationStatus[k].name;
      topPriority = notificationStatus[k].priority;
    }
  }
  return notificationName;
}

export function getTopTrainingPriority(
  notificationStatus: TrainingNotificationTypes | null,
): AvailableTrainingNotifications | null {
  if (notificationStatus === null) {
    return null;
  }
  let notificationName = null;
  let topPriority = Number.MAX_SAFE_INTEGER;
  let k: keyof TrainingNotificationTypes;
  for (k in notificationStatus) {
    if (
      notificationStatus[k].active &&
      notificationStatus[k].priority < topPriority
    ) {
      notificationName = notificationStatus[k].name;
      topPriority = notificationStatus[k].priority;
    }
  }
  return notificationName;
}
